function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { cover, hideText } from "polished";
import styled, { css, createGlobalStyle } from "styled-components";
import getResponsiveBackgroundImageStyles from "../../../helpers/getResponsiveBackgroundImageStyles";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import throwError from "../../../utils/throwError";
import unit from "../../../utils/unit";
import Link from "../../quarks/Link";
import { sizesSpace } from "../ContainerOrg";
import { backgrounds, spacingSpace } from "./SectionOrg.settings";
export var getSpacingSpaceValue = function getSpacingSpaceValue(spacingValue, breakpointValue) {
  if (typeof spacingValue === "number") {
    return space(spacingValue);
  }
  if (!breakpointValue) {
    return throwError('If "spacingValue" is a type of object, "breakpointValue" must be defined!');
  }
  return space(spacingValue[breakpointValue]);
};
var spacingPaddingStyle = function spacingPaddingStyle(topSpacing, bottomSpacing) {
  var topSpacingValue = spacingSpace[topSpacing];
  var bottomSpacingValue = spacingSpace[bottomSpacing];
  if (typeof topSpacingValue === "number" && typeof bottomSpacingValue === "number") {
    return css(["padding:", " 0 ", " 0;"], getSpacingSpaceValue(topSpacingValue), getSpacingSpaceValue(bottomSpacingValue));
  }
  return css(["padding:", " 0 ", " 0;", "{padding:", " 0 ", " 0;}", "{padding:", " 0 ", " 0;}"], getSpacingSpaceValue(topSpacingValue, "small"), getSpacingSpaceValue(bottomSpacingValue, "small"), breakpoint("medium"), getSpacingSpaceValue(topSpacingValue, "medium"), getSpacingSpaceValue(bottomSpacingValue, "medium"), breakpoint("large"), getSpacingSpaceValue(topSpacingValue, "large"), getSpacingSpaceValue(bottomSpacingValue, "large"));
};
var spacingStyle = function spacingStyle(spacing) {
  if (_typeof(spacing) === "object" && "top" in spacing) {
    return spacingPaddingStyle(spacing.top, spacing.bottom);
  }
  if (_typeof(spacing) === "object" && "small" in spacing) {
    return css(["", ";", "{", ";}", "{", ";}"], spacingPaddingStyle(spacing.small.top, spacing.small.bottom), breakpoint("medium"), spacingPaddingStyle(spacing.medium.top, spacing.medium.bottom), breakpoint("large"), spacingPaddingStyle(spacing.large.top, spacing.large.bottom));
  }
  return spacingPaddingStyle(spacing, spacing);
};
var getSectionMinHeight = function getSectionMinHeight(isFullHeight, offsetUnit) {
  if (isFullHeight && offsetUnit) {
    return css(["min-height:calc(100vh - ", ");@supports (min-height:100dvh){min-height:calc(100dvh - ", ");}"], unit(offsetUnit), unit(offsetUnit));
  }
  if (isFullHeight && !offsetUnit) {
    return css(["min-height:100vh;@supports (min-height:100dvh){min-height:100dvh;}"]);
  }
  return css(["min-height:auto;"]);
};
var getSectionMinHeightBreakpoints = function getSectionMinHeightBreakpoints(isFullHeight, offsetUnit) {
  if (typeof offsetUnit === "number") {
    return css(["", ""], getSectionMinHeight(isFullHeight, offsetUnit));
  }
  return css(["", "{", "}", "{", "}", "{", "}"], breakpoint("small"), getSectionMinHeight(isFullHeight, offsetUnit === null || offsetUnit === void 0 ? void 0 : offsetUnit.small), breakpoint("medium"), getSectionMinHeight(isFullHeight, offsetUnit === null || offsetUnit === void 0 ? void 0 : offsetUnit.medium), breakpoint("large"), getSectionMinHeight(isFullHeight, offsetUnit === null || offsetUnit === void 0 ? void 0 : offsetUnit.large));
};

/**
 * Set "content-visibility" related styles only when an element is not in a viewport. Otherwise, "content-visibility" can cause problems with rendering interactive elements
 * */
export var StyledSectionOrg = styled.section.withConfig({
  componentId: "sc-2vg2z1-0"
})(function (_ref) {
  var $color = _ref.$color,
    $spacing = _ref.$spacing,
    $backgroundImage = _ref.$backgroundImage,
    $isInView = _ref.$isInView,
    $height = _ref.$height,
    $hasSeparator = _ref.$hasSeparator,
    $hasOverflowHidden = _ref.$hasOverflowHidden,
    $isFillingRemainingSpace = _ref.$isFillingRemainingSpace,
    $hasHorizontalGradient = _ref.$hasHorizontalGradient,
    $sectionsSumClientHeight = _ref.$sectionsSumClientHeight,
    $customColor = _ref.$customColor,
    $zIndex = _ref.$zIndex,
    $isFullViewportHeight = _ref.$isFullViewportHeight,
    $viewportHeightOffsetUnit = _ref.$viewportHeightOffsetUnit,
    $isContentVerticalCenter = _ref.$isContentVerticalCenter,
    theme = _ref.theme;
  var backgroundColorName = backgrounds[$color];
  var backgroundColor = getColor(theme, backgroundColorName);
  var toColor = theme.colors[backgroundColorName].toColor;
  return css(["", ";position:relative;background:", ";", " content-visibility:", ";contain-intrinsic-size:", ";", " ", " background-repeat:no-repeat;", " ", " ", " ", " ", ""], !$isContentVerticalCenter ? spacingStyle($spacing) : null, $customColor || toColor || backgroundColor, getSectionMinHeightBreakpoints($isFullViewportHeight, $viewportHeightOffsetUnit), !$isInView && "auto", !$isInView && "0 ".concat(unit($height)), $zIndex && css(["z-index:", ";"], $zIndex), $isFillingRemainingSpace && css(["min-height:calc(100vh - ", ");"], unit($sectionsSumClientHeight)), toColor && css(["background-image:linear-gradient( ", " ", ",", " );background-repeat:no-repeat;"], $hasHorizontalGradient && "to right,", backgroundColor, toColor), $backgroundImage && getResponsiveBackgroundImageStyles($backgroundImage, toColor, backgroundColor, $hasHorizontalGradient), $hasSeparator && css(["&::after{content:\"\";position:absolute;bottom:0;left:50%;width:100%;max-width:", ";height:", ";background:", ";transform:translate(-50%,50%);}"], space(sizesSpace["default"]), unit(1), getBorderColor(theme, backgroundColorName, "medium")), $hasOverflowHidden ? css(["overflow:hidden;"]) : null, $isContentVerticalCenter ? css(["display:flex;align-items:center;& > div{flex:1;}"]) : null);
});
export var FullscreenBackground = createGlobalStyle(function (_ref2) {
  var theme = _ref2.theme,
    $color = _ref2.$color;
  return css(["body{background:", ";}"], getColor(theme, backgrounds[$color]));
});
export var SectionLink = styled(Link).withConfig({
  componentId: "sc-2vg2z1-1"
})(["", ";", ";"], cover(), hideText());